import { toJsDate } from "./toJsDate";

export class CommonFunctions {
  static formatDuration(ms: number): string {
    const seconds = Math.floor(ms / 1000) % 60;
    const minutes = Math.floor(ms / (1000 * 60)) % 60;
    const hours = Math.floor(ms / (1000 * 60 * 60));
    return [
      hours > 0 ? `${hours}h` : "",
      minutes > 0 ? `${minutes}m` : "",
      `${seconds}s`,
    ]
      .filter(Boolean)
      .join(" ");
  }

  static calculateAge(dateOfBirth: string | undefined): number {
    if (!dateOfBirth) return 0;
    const birthDate = toJsDate(dateOfBirth);
    const today = new Date();
    if (!birthDate || isNaN(birthDate.getTime())) return 0;
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  // Helper to remove undefined fields recursively
  static removeUndefined(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(CommonFunctions.removeUndefined);
    } else if (obj && typeof obj === "object") {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, v]) => v !== undefined)
          .map(([k, v]) => [k, CommonFunctions.removeUndefined(v)]),
      );
    }
    return obj;
  }

  static logObject(obj: Record<string, any>) {
    for (const key in obj) {
      // Ensure the property belongs to the object itself, not its prototype chain
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        // If the value is an object (and not null, as typeof null is 'object')
        if (typeof value === "object" && value !== null) {
          // If it's an array, iterate through its elements and recurse
          if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
              // Check if array element is an object and recurse
              if (typeof value[i] === "object" && value[i] !== null) {
                CommonFunctions.logObject(value[i]);
              } else {
                // Process non-object array elements here
              }
            }
          } else {
            // If it's a plain object, recurse into it
            CommonFunctions.logObject(value);
          }
        } else {
          // Process primitive values here
        }
      }
    }
  }
}
